export class ApiDown{
    constructor(){

    };
}